export default class Slider{
    constructor(containerSelector,preBtnSelector,nextSelector,max){
        this.el_container = document.querySelector(containerSelector);
        this.curIndex = 0;
        if(undefined !== preBtnSelector){
            this.el_prevBtn = document.querySelector(preBtnSelector);
        }
        if(undefined !== nextSelector){
            this.el_nextBtn = document.querySelector(nextSelector);
        }
        this.max = max;
        this.min = 0;
        this.interval = 2000;
        this.timmer = null;
    }

    init(slideW){
        this.slideW = slideW;
        try{
            this.el_prevBtn.addEventListener("click",()=>{
                this.showPrev();
                this.resetTimmer();
            })
            this.el_nextBtn.addEventListener("click",()=>{
                this.showNext();
                this.resetTimmer();
                
            })
        }catch(e){}
        if( this.max < 0){
            this.max = 0
        }
        if( this.min < 0){
            this.min = 0
        }
    }

    resetTimmer(){
        if(null !== this.timmer){
            clearInterval(this.timmer);
            this.setTimer();
        }
    }

    setTimer(){
        this.timmer = setInterval(this.showNext.bind(this),this.interval);
    }


    appendSwitcher(selector,index){
        if("string" === typeof selector){
            document.querySelector(selector).addEventListener("click",()=>{
                this.curIndex = index;
                this.showIndex();
                this.resetTimmer();
            })
        }else{
            selector.addEventListener("click",()=>{
                this.curIndex = index;
                this.showIndex();
                this.resetTimmer();
            })
        }
      
        return this;
    }

    showIndex(){
        let tranlate = this.slideW * this.curIndex;
        let transform = `translateX(-${tranlate}px)`;
        this.el_container.style.transform = transform;
        if("function" == typeof this.onShowIndex){
            this.onShowIndex(this.curIndex);
        }

    }
    showPrev(){
        if(this.curIndex == this.min){
            this.curIndex  = this.max;
        }else{
            this.curIndex--;
        }
      
        this.showIndex();
    }
    
    showNext(){
        if(this.max -1 === this.curIndex){
            this.curIndex =  this.min;
        }else{
            this.curIndex++;
        }
        this.showIndex();
    }
}